import { render } from "./GalleryManager.vue?vue&type=template&id=5753f31e&scoped=true&ts=true"
import script from "./GalleryManager.vue?vue&type=script&lang=ts"
export * from "./GalleryManager.vue?vue&type=script&lang=ts"

import "./GalleryManager.vue?vue&type=style&index=0&id=5753f31e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5753f31e"]])

export default __exports__